<div fxLayout="column" fxLayoutGap="24px" fxFlexFill>
  <ng-content></ng-content>
</div>